import React from 'react';
import { Link } from 'react-router-dom';
// import MediaCard from '../mediacard/mediacard.component';
import './mediasection.styles.css';


const MediaSection = () => (
    <section className="section-features">
         <div className="row">    
         <div className="col-1-of-4">
            <a className="feature-box-social-link" href="https://www.instagram.com/pk.greben/" target="_blank">
                <div className="feature-box">                   
                    <i className="feature-box__icon icofont-instagram"></i>
                    <h3 className="heading-tertiary u-margin-bottom-small">Instagram</h3>
                    <p className="feature-box__text">
                    Sve fotografije sa naših akcija možete videti na našem zvaničnom Instagram nalogu.
                    </p>                
                </div>
            </a>
        </div>      
        <div className="col-1-of-4">
            <a className="feature-box-social-link" href="https://www.facebook.com/groups/226608860781513/" target="_blank">
                <div className="feature-box">                   
                    <i className={`feature-box__icon icofont-facebook`}></i>
                    <h3 className="heading-tertiary u-margin-bottom-small">Facebook</h3>
                    <p className="feature-box__text">
                    Najnovije vesti o akcijama PK Greben, pratite na našoj Facebook stranici.
                    </p>                
                </div>
            </a>
        </div>      
        <div className="col-1-of-4">
            <Link to="/godisnjiplan" className="feature-box-social-link" >
                <div className="feature-box">                   
                    <i className="feature-box__icon icofont-ui-calendar"></i>
                    <h3 className="heading-tertiary u-margin-bottom-small">Godisnji Plan</h3>
                    <p className="feature-box__text">
                    Godišnji Plan akcija PK Greben za kalendarsku 2020. godinu.
                    </p>                
                </div>
            </Link>
        </div>      
        <div className="col-1-of-4">
            <Link to="/nastim" className="feature-box-social-link" >
                <div className="feature-box">                   
                    <i className="feature-box__icon icofont-contacts"></i>
                    <h3 className="heading-tertiary u-margin-bottom-small">Kontakt</h3>
                    <p className="feature-box__text">
                    Članovi uprave Planinarskog Kluba Grebn - Kontakt podaci.
                    </p>                
                </div>
            </Link>
        </div>                  
            {/* <MediaCard
            link= {'https://www.instagram.com/pk.greben/'}
            media={'instagram'}
            title={'Instagram'}
            text={'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, ipsum sapiente aspernatur.'}
            />
             <MediaCard
            link = {'https://www.facebook.com/groups/226608860781513/'} 
            media={'facebook'} 
            title={'Facebook'}
            text={'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, ipsum sapiente aspernatur.'}
            />
             <MediaCard
            media={'viber'}
            title={'Godisnji Plan'}
            text={'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, ipsum sapiente aspernatur.'}
            />
             <MediaCard
            media={'compass'} 
            title={'Live a healthier life'}
            text={'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam, ipsum sapiente aspernatur.'}
            /> */}
        </div>
    </section>
);


export default MediaSection;